<template>
  <div class="kpi mt-3">
    <v-card class="custom_card" background="#fff">
      <!-- Header -->
      <v-layout class="header pa-4" align-center>
        <v-flex shrink class="mb-n8">
          <v-img
            eager
            width="80"
            height="80"
            :src="require('../../assets/images/dashboard/ranking.png')"
          ></v-img>
        </v-flex>
        <v-flex shrink style="color: #fff">
          <div class="font-24 font-w-700">ตัวชี้วัดผลการดำเนินงานของ</div>
          <div class="font-16 font-w-700">
            (Key Performance Indicators: KPIs)
          </div>
        </v-flex>
      </v-layout>

      <!-- body -->
      <div class="pa-6">
        <!-- Section 1 -->
        <v-layout class="pa-4">
          <!-- ผลกระทบทางเศรษฐกิจ -->
          <v-flex xs4 class="pl-6">
            <div class="font-16 font-w-700">ผลกระทบทางเศรษฐกิจ</div>
            <div class="pl-4 font-14">ของผู้ประกอบการรวมต่อปี</div>
            <div class="mt-8 economic__impact">
              {{ checkFormatNummber(data.economyEconomy)
              }}<span class="font-40">฿</span>
              <v-img
                style="position: absolute; bottom: 0; right: 0"
                width="137"
                height="137"
                :src="require('../../assets/images/dashboard/coin.png')"
              ></v-img>
            </div>
          </v-flex>

          <!-- มูลค่าการลงทุนเพิ่มใน R & D -->
          <v-flex xs4 class="pl-6 con_rd">
            <div class="font-16 font-w-700">มูลค่าการลงทุนเพิ่มใน R & D</div>
            <div class="pl-4 font-14">ของผู้ใช้บริการต่อปี</div>
            <div class="mt-8 r_and_d">
              {{ checkFormatNummber(data.RDInvestValue)
              }}<span class="font-40">฿</span>
            </div>
            <v-img
              style="position: absolute; bottom: 0; right: 0"
              width="100%"
              height="100%"
              :src="require('../../assets/images/dashboard/trend-up.png')"
            ></v-img>
          </v-flex>

          <!-- คะแนนความพึงพอใจรวม -->
          <v-flex xs4 style="position: relative" class="pl-6">
            <div class="font-16 font-w-700">คะแนนความพึงพอใจรวม</div>
            <div class="pl-4 font-14">
              ของผู้ใช้บริการโดยเฉลี่ยทุกแผนงานรายปี
            </div>
            <div class="satisfaction_score">
              {{ checkFormatNummber(data.totalSatisfiedScore)
              }}<span class="font-40">%</span>
            </div>
            <v-img
              style="position: absolute; bottom: 0; right: 0"
              width="137"
              height="137"
              :src="require('../../assets/images/dashboard/Handshake.png')"
            ></v-img>
          </v-flex>
        </v-layout>

        <v-divider style="border-width: 1px" />

        <!-- Section 2 -->
        <v-layout class="px-4 pt-4">
          <!-- จำนวนผลิตภัณฑ์/บริการใหม่ -->
          <v-flex xs3 class="pl-4">
            <div class="font-16 font-w-700">จำนวนผลิตภัณฑ์/บริการใหม่</div>
            <div class="font-14 text-center">ที่เสนอขายในตลาดต่อปี</div>
            <v-layout class="pr-4" justify-center>
              <v-flex shrink>
                <v-img
                  width="100%"
                  :src="require('../../assets/images/dashboard/graph-star.png')"
                >
                  <div class="new_product pt-9">
                    <div>{{ checkFormatNummber(data.productAmount) }}</div>
                    <div class="font-32 mt-n6 font-pr">รายการ</div>
                  </div>
                </v-img>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- ร้อยละผู้ใช้บริการ -->
          <v-flex
            xs6
            class="px-4"
            style="
              border-left: 2px solid #d3d3d3;
              border-right: 2px solid #d3d3d3;
              display: flex;
              flex-direction: column;
            "
          >
            <v-layout>
              <v-flex
                xs6
                style="
                  border-right: 1px solid #d3d3d3;
                  border-bottom: 2px solid #d3d3d3;
                "
              >
                <div class="font-16 font-w-700">ร้อยละผู้ใช้บริการ</div>
                <div class="pl-4 font-14">ที่เพิ่มขึ้นต่อปี</div>
                <v-layout align-center justify-space-between>
                  <v-flex shrink>
                    <v-img
                      width="65"
                      height="65"
                      contain
                      :src="require('../../assets/images/dashboard/up.png')"
                    ></v-img>
                  </v-flex>
                  <v-flex shrink class="font-64 font-w-700 txt_orange font-pp">
                    {{ checkFormatNummber(data.userServicePercent)
                    }}<span class="font-32">%</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs6
                style="
                  border-left: 1px solid #d3d3d3;
                  border-bottom: 2px solid #d3d3d3;
                "
                class="pl-4"
              >
                <div class="font-16 font-w-700">อัตราผลตอบแทน</div>
                <div class="pl-4 font-14">จากการลงทุน ROI</div>
                <v-layout align-center justify-space-between>
                  <v-flex shrink>
                    <v-img
                      width="65"
                      height="65"
                      contain
                      :src="
                        require('../../assets/images/dashboard/line-chart-fill.png')
                      "
                    ></v-img>
                  </v-flex>
                  <v-flex shrink class="font-64 font-w-700 txt_orange font-pp">
                    {{ checkFormatNummber(data.rateOfReturn)
                    }}<span class="font-32">%</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout justify-space-between mt-3>
              <v-flex shrink>
                <div class="font-16 font-w-700">ผลประกอบการ</div>
                <div class="pl-4 font-14">ต่องบประมาณ</div>
              </v-flex>
              <v-flex shrink class="txt_green" style="margin-bottom: -2rem">
                <span style="font-size: 76px" class="font-w-700 font-pp">
                  {{ checkFormatNummber(data.turnoverPerBudget) }}
                </span>
                <span class="font-32 font-w-600 font-pr">เท่า</span>
              </v-flex>
              <v-flex shrink>
                <v-img
                  width="110"
                  contain
                  :src="
                    require('../../assets/images/dashboard/hand-coin-line.png')
                  "
                ></v-img>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- ร้อยละของรายได้รวม -->
          <v-flex xs3 style="position: relative" class="pl-6">
            <div class="font-16 font-w-700">ร้อยละของรายได้รวม</div>
            <div class="pl-4 font-14">ที่เพิ่มขึ้นต่อปี</div>
            <div class="satisfaction_score">
              {{ checkFormatNummber(data.totalIncomeRate)
              }}<span class="font-40">%</span>
            </div>
            <v-img
              style="position: absolute; bottom: 0; right: 0"
              width="200"
              height="200"
              contain
              aspect-ratio="1"
              :src="require('../../assets/images/dashboard/refund-2-line.png')"
            ></v-img>
          </v-flex>
        </v-layout>

        <v-divider style="border-width: 1px" />

        <!-- Section 3 -->
        <v-layout class="mt-4 px-4">
          <v-flex
            xs6
            style="
              position: relative;
              border-right: 1px solid #d3d3d3;
              width: 100%;
            "
          >
            <v-layout justify-space-between align-center>
              <v-flex shrink>
                <div class="font-16 font-w-700">
                  ร้อยละของรายได้จากการถ่ายทอดเทคโนโลยี
                </div>
                <div class="font-14 pl-4">ที่เพิ่มขึ้นต่อปี</div>
                <div shrink class="font-64 font-w-700 txt_orange font-pp">
                  {{ checkFormatNummber(data.technologyIncomeRate)
                  }}<span class="font-32">%</span>
                </div>
              </v-flex>
              <v-flex shrink pr-6>
                <v-img
                  width="130"
                  height="130"
                  contain
                  aspect-ratio="1"
                  :src="
                    require('../../assets/images/dashboard/pie-chart-line.png')
                  "
                ></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs6
            class="pl-6"
            style="position: relative; border-left: 1px solid #d3d3d3"
          >
            <v-layout justify-space-between align-center>
              <v-flex shrink>
                <div class="font-16 font-w-700">การจ้างงานรวม</div>
                <div class="font-14 pl-4">ต่อปี</div>
                <div shrink class="font-64 font-w-700 font-pp">
                  {{ checkFormatNummber(data.totalHireAmount)
                  }}<span class="font-32 font-pr"> ฿/ราย</span>
                </div>
              </v-flex>
              <v-flex shrink pr-6>
                <v-img
                  width="130"
                  height="130"
                  contain
                  aspect-ratio="1"
                  :src="
                    require('../../assets/images/dashboard/contacts-line.png')
                  "
                ></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider class="mt-4" style="border-width: 1px" />

        <!-- Section 4 -->
        <v-layout class="mt-4">
          <v-flex xs3 class="pa-3" style="border-right: 1px solid #d3d3d3">
            <div class="font-16 font-w-700">ระดับการพัฒนา</div>
            <div class="font-14 text-center">
              กระบวนการภายในของอุทยานวิทยาศาสตร์ภูมิภาค
            </div>
            <v-progress-circular
              class="mt-4"
              style="width: 100%; height: 80%"
              :rotate="-90"
              :size="100"
              :width="15"
              :value="data.developmentAmount"
              color="#3B608A"
            >
              <div class="d-flex flex-column">
                <div class="font-48 font-w-700 txt_blue font-pp">
                  {{ data.developmentAmount }}
                </div>
                <div class="font-18 font-w-600 font-pr" style="color: #3b608a">
                  คะแนน
                </div>
              </div>
            </v-progress-circular>
          </v-flex>

          <v-flex
            xs3
            class="pa-3"
            style="
              border-right: 1px solid #d3d3d3;
              border-left: 1px solid #d3d3d3;
            "
          >
            <div class="font-16 font-w-700">
              ระดับของการสร้างความตะหนักถึงการมีอยู่ของอุทยานวิทยาศาสตร์ภูมิภาคในพื้นที่
            </div>
            <div class="font-14 text-center">
              และการสร้างชื่อเสียงให้แก่อุทยานวิทยาศาสตร์ภูมิภาค
            </div>
            <div class="text-center font-64 font-w-700 font-pp txt_blue mt-4">
              {{ data.realizeAmount }}
            </div>
            <div class="text-center font-40 font-w-500 font-pr txt_blue mt-n6">
              คะแนน
            </div>
          </v-flex>

          <v-flex
            xs3
            class="pa-3"
            style="
              border-right: 1px solid #d3d3d3;
              border-left: 1px solid #d3d3d3;
            "
          >
            <div class="font-16 font-w-700">สัดส่วนงานวิจัย IP ที่ถ่ายทอด</div>
            <div class="font-14 text-center">
              ต่อจำนวนงานวิจัยIP พร้อมใช้ในปี
            </div>
            <v-img
              class="mt-6"
              width="100%"
              height="200"
              contain
              aspect-ratio="1"
              :src="require('../../assets/images/dashboard/Handshake.png')"
            >
              <div class="satisfaction_score text-center">
                {{ checkFormatNummber(data.ipResearchRate)
                }}<span class="font-40">%</span>
              </div>
            </v-img>
          </v-flex>

          <v-flex xs3 class="pa-3" style="border-left: 1px solid #d3d3d3">
            <div class="font-16 font-w-700">จำนวนนิติบุคคลใหม่</div>
            <div class="font-14 pl-6">
              ที่จัดตั้งภายใต้อุทยานวิทยาศาสตร์ภูมิภาคต่อปี
            </div>
            <div style="font-size: 76px" class="font-w-700 font-pp pl-4">
              {{ checkFormatNummber(data.newJuristic) }}
            </div>
            <div class="font-40 font-w-500 mt-n6 pl-6 font-pr">ราย</div>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import moment from "moment";
export default {
  name: "KPI",
  props: {
    filter: {
      type: Object,
      default: () => ({
        plan_id: "",
        region_id: "",
        year: "",
      }),
    },
    exportExcel: {
      type: Boolean,
      default: false,
    },
    region: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    data: {
      // section 1
      economyEconomy: 0,
      RDInvestValue: 0,
      totalSatisfiedScore: 0,
      // section 2
      productAmount: 0,
      userServicePercent: 0,
      rateOfReturn: 0,
      turnoverPerBudget: 0,
      totalIncomeRate: 0,
      // section 3
      technologyIncomeRate: 0,
      totalHireAmount: 0,
      // section 4
      developmentAmount: 0,
      realizeAmount: 0,
      ipResearchRate: 0,
      newJuristic: 0,
    },
  }),
  watch: {
    filter: {
      handler: function (val) {
        this.getData();
      },
      deep: true,
    },
    exportExcel: function (val) {
      if (val) {
        this.exportToExcel();
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await this.$apiFire("Dashboard/kpi", this.filter);
      if (res) {
        this.data = res;
      }
    },
    checkFormatNummber(number) {
      if (!number) return 0;
      number = parseFloat(number).toFixed(1);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    exportToExcel() {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // ส่วนหัวข้อ งบประมาณ
      let doc_date = moment().add(543, "year").format("DDMMYYYY");
      const topicRow = [
        "KPI/KRI ตัวชี้วัดผลการดำเนินงานของอุทยานวิทยาศาสตร์ภูมิภาค (Key Performance Indicators: KPIs)",
        "ข้อมูล ณ วันที่ " + doc_date,
      ];
      XLSX.utils.sheet_add_aoa(worksheet, [topicRow], { origin: "A1" });

      let jsonExcelSection1 = [];
      jsonExcelSection1.push({
        ลำดับ: 1,
        ภูมิภาค: this.filter.region_id
          ? this.region.find((e) => e.id == this.filter.region_id)?.name
          : "ทั้งหมด",
        "ปี งปม.": this.filter.year ? this.filter.year : "ทั้งหมด",
        ผลกระทบทางเศรษฐกิจของผู้ประกอบการรวมต่อปี: this.checkFormatNummber(
          this.data.economyEconomy
        ),
        "มูลค่าการลงทุนเพิ่มใน R&D ของผู้ใช้บริการต่อปี":
          this.checkFormatNummber(this.data.RDInvestValue),
        คะแนนความพึงพอใจรวมของผู้ใช้บริการโดยเฉลี่ยทุกแผนงานรายปี:
          this.checkFormatNummber(this.data.totalSatisfiedScore),
        "จำนวนผลิตภัณฑ์/บริการใหม่ที่เสนอขายในตลาดต่อปี":
          this.checkFormatNummber(this.data.productAmount),
        ร้อยละผู้ใช้บริการที่เพิ่มขึ้นต่อปี: this.checkFormatNummber(
          this.data.userServicePercent
        ),
        "อัตราผลตอบแทนจากการลงทุน ROI": this.checkFormatNummber(
          this.data.rateOfReturn
        ),
        ร้อยละของรายได้รวมที่เพิ่มขึ้นต่อปี: this.checkFormatNummber(
          this.data.totalIncomeRate
        ),
        ผลประกอบการต่องบประมาณ: this.checkFormatNummber(
          this.data.turnoverPerBudget
        ),
        ร้อยละของรายได้จากการถ่ายทอดเทคโนโลยีที่เพิ่มขึ้นต่อปี:
          this.checkFormatNummber(this.data.technologyIncomeRate),
        การจ้างงานรวมต่อปี: this.checkFormatNummber(this.data.totalHireAmount),
        ระดับการพัฒนากระบวนการภายในของอุทยานฯ: this.data.developmentAmount,
        ระดับของการสร้างความตะหนักถึงการมีอยู่ของอุทยานฯในพื้นที่และการสร้างชื่อเสียงให้แก่อุทยานฯ:
          this.data.realizeAmount,
        "สัดส่วนงานวิจัย IP ที่ถ่ายทอดต่อจำนวนงานวิจัยIP พร้อมใช้ในปี":
          this.checkFormatNummber(this.data.ipResearchRate),
        จำนวนนิติบุคคลใหม่ที่จัดตั้งภายใต้อุทยานฯต่อปี: this.checkFormatNummber(
          this.data.newJuristic
        ),
      });

      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "A2",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `KPI_dashboard_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      this.$emit("clearExportExcel", false);
    },
  },
};
</script>

<style lang="scss">
.kpi {
  .v-progress-circular__overlay {
    stroke-linecap: round;
  }

  .custom_card {
    border-radius: 20px;
    .header {
      background: linear-gradient(0deg, #f15a29 6.18%, #fbb040 84.83%);
    }
  }

  .economic__impact {
    position: relative;
    font-weight: 700;
    font-size: 64px;
    color: #f19782;
    font-family: "Poppins";
    text-align: center;
  }
  .r_and_d {
    position: relative;
    font-weight: 700;
    font-size: 64px;
    color: #f7941d;
    font-family: "Poppins";
    text-align: center;
  }
  .economic__impact {
    font-size: clamp(32px, 2.5vw, 64px) !important;
  }

  .r_and_d {
    font-size: clamp(32px, 2.5vw, 64px) !important;
  }

  .satisfaction_score {
    font-size: clamp(36px, 2.8vw, 76px) !important;
  }

  .new_product {
    font-size: clamp(32px, 2.5vw, 76px) !important;
  }

  .font-64 {
    font-size: clamp(28px, 2.2vw, 64px) !important;
  }

  .font-48 {
    font-size: clamp(24px, 2.5vw, 48px) !important;
  }

  /* เพิ่ม responsive สำหรับ font-32 ในส่วนของ ฿/ราย */
  .font-32 {
    font-size: clamp(16px, 1.8vw, 32px) !important;
  }

  /* Responsive for inline font-size styles */
  [style*="font-size: 76px"] {
    font-size: clamp(32px, 2.8vw, 76px) !important;
  }
  .con_rd {
    border-left: 2px solid #d3d3d3;
    border-right: 2px solid #d3d3d3;
    position: relative;
    .rd {
      position: relative;
      font-weight: 700;
      font-size: 64px;
      color: #f19782;
      font-family: "Poppins";
      text-align: center;
    }
  }

  .satisfaction_score {
    position: relative;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 76px;
    color: #f7941d;
    margin-bottom: -2rem;
    padding-left: 14px;
    padding-top: 8px;
  }
  .new_product {
    font-family: "Poppins";
    font-weight: 700;
    font-size: 76px;
    text-align: center;
    color: #f9bb43;
  }
}
.txt_orange {
  color: #f7941d;
}
.txt_green {
  color: #216957;
}
.txt_blue {
  color: #3b608a;
}
.font-pp {
  font-family: "Poppins";
}
</style>
